<template>
  <div class="participant-wrap">
    <div class="par-content">
      <!-- 标签 -->
      <div class="tag-box" v-if="tagList && tagList.length > 0">
        <div v-for="item in tagList">
          <toolTip class="tag-item bgActive2" :class="{'check': tagIsCheck(item.projectMemberHasLabel)}" :title="item.label_name" maxWidth="107px" @click.native="tagHandlerClick(item)">{{item.label_name}}</toolTip>
        </div>

      </div>
      <!-- 人员树 -->
      <div class="par-content-left">
        <div class="search-content">
          <div class="top-search">
            <el-input prefix-icon="icon iconfont iconicon_search1" v-model="searchInput" size="mini" placeholder="输入要添加的成员" clearable></el-input>
          </div>
          <div class="tree-box">
            <el-tree
              :props="{ multiple: true, emitPath: false, value:'uid', label:'realname', children:'children' }"
              :data="taskMemberlist"
              node-key="uid"
              show-checkbox
              :filter-node-method="filterNode"
              empty-text="暂无此成员"
              ref="tree"
              @check="onChange">
            </el-tree>
            <div class="all-footer" @click="showAll" v-if="!searchInput && parentId && !disabledShowAll">
              <i class="icon iconfont iconicon_drop_down_arrow rota90"></i>
              显示本项目成员
            </div>
          </div>
        </div>
      </div>
      <!-- 已选人员 -->
      <div class="par-content-right" v-loading="rightLoading">
        <div class="top-filter">
          <p>已选：{{selectCount}}个成员</p>
          <span class="text-red" @click="clearPanel" :class="{'disabled': selectCount === 0}">清空</span>
        </div>
        <div class="checked-list">
          <div class="checked-box" v-for="(item, index) in allData" :key="`${index}_${item.realname}`" v-if="item.childrenCount > 0">
            <span>{{item.realname}}</span>
            <div class="checked-item" v-for="temp in item.children" :key="temp.uid" v-if="temp.isChecked">
              <div class="flex">
                <Myavatar width="30px" height="30px" :imgUrl="temp.user_avatar" :userName="temp.realname"></Myavatar>
                {{temp.realname}}
              </div>
              <span  class="del text-red" v-show="lockUid.indexOf(temp.uid) < 0" @click="removeChecked(temp.uid)">移除</span>
            </div>
          </div>

          <Nothing v-if="selectCount === 0" :config="{tip: '暂无成员'}" width="88"></Nothing>
        </div>
      </div>
    </div>
    <div class="par-bottom">
      <div class="par-left-btns">
      </div>
      <div class="par-bottom-btns">
        <span class="cancel text-btn-active" @click="close"  style="margin-right:30px;">取消</span>
        <wf-button type="primary" @click="confirm">保存</wf-button>
      </div>
    </div>
  </div>
</template>

<script>
import Nothing from '@/components/nothing'
export default {
  name: "",
  components: {
    Nothing
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    lockUid: {
      type: Array,
      default: () => {
        return []
      }
    },
    taskMemberlist: {
      type: Array,
      default: () => {
        return []
      }
    },
    delArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    tagList: [Array],
    parentId: [Number, String]
  },
  data() {
    return {
      selectItems: [], // 选择项
      saveMember: [],
      delMember: [],
      loading: false, // 加载动画
      searchInput: '',
      localList: [],
      selectData: [],
      tpData: [],
      disabledShowAll: false,
      rightLoading: false,
      realTagList: []
    }
  },
  computed: {
    allData() {
      let arr = JSON.parse(JSON.stringify(this.taskMemberlist))
      let users = [...this.delMember, ...this.saveMember].map(res => res.uid)
      arr.map(res => {
        res.children.map(temp => {
          if (users.includes(temp.uid)) {
            this.$set(temp, 'isChecked', true)
          }
        })
        this.$set(res, 'childrenCount', res.children.filter(temp => temp.isChecked).length)
      })
      console.log('------vvvv-----', arr)
      return arr
    },
    selectCount() {
      //this.allData里面的children的isChecked属性等于true的数量
      return this.allData.reduce((total, item) => {
        return total + item.children.filter(temp => temp.isChecked).length
      }, 0)
    },
    tagIsCheck() {
      return (data) => {
        let users = [...this.delMember, ...this.saveMember].map(res => res.uid)
        let selectId = data.map(res => res.project_member_uid)
        return selectId.every(item => users.includes(item))
      }
    }
  },
  created() {

  },
  watch: {
    value: {
      handler() {
        if (this.value && this.value.length > 0) {
          this.selectItems = this.value ? this.value.map(res => res.uid) : []
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.selectItems, true)
          })
          this.rightLoading = true
          setTimeout(() => {
            this.onChange()
            this.rightLoading = false
          }, 1000)
          this.delMember = JSON.parse(JSON.stringify(this.delArr))
          return this.value
        } else {
          this.selectItems = []
          this.saveMember = []
        }
      },
      immediate: true
    },
    searchInput(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.realname.indexOf(value) !== -1;
    },
    // 移除选中的选项
    removeChecked(uid) {
      if(this.lockUid.indexOf(uid) > -1) return
      let flag = this.delMember.findIndex(res => res.uid == uid)
      if(flag > -1) {
        this.delMember.splice(flag, 1)
      } else {
        this.$refs.tree.setChecked(uid, false)
        this.$nextTick(() => {
          this.onChange()
        })
      }
    },
    // 关闭
    close() {
      this.$emit("close")
    },
    confirm() {
      this.$emit("confirm", [...this.delMember, ...this.saveMember])
    },
    clearPanel() {
      this.$refs.tree.setCheckedKeys(this.lockUid, true)
      this.$nextTick(() => {
        this.delMember = []
        this.onChange()
      })
    },
    onChange(val) {
      this.saveMember = JSON.parse(JSON.stringify(this.$refs.tree.getCheckedNodes(true, false)))
      // console.log('--------------asd----------', this.lockUid, this.value, this.saveMember)
    },
    showAll() {
      this.disabledShowAll = true
      this.$emit('showAll')
    },
    tagHandlerClick(item) {
      console.log(item)
      let flg = this.tagIsCheck(item.projectMemberHasLabel)
      if (flg) {
        item.projectMemberHasLabel.forEach(res => {
          this.removeChecked(res.project_member_uid)
        })
      } else {
        let users = item.projectMemberHasLabel.map(res => res.project_member_uid)
        users.forEach(res => {
          this.$refs.tree.setChecked(res, true)
        })
        this.$nextTick(() => {
          this.onChange()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
::v-deep {

  .el-cascader-node.is-active{
    color:initial;
  }
  .el-cascader-node.in-active-path{
    color: initial;
  }
}
.participant-wrap {
  // padding: 10px;
  height: 553px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  .tree-box {
    height: 0;
    flex: 1;
    overflow: auto;
    padding: 16px 24px;
  }
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  /deep/ {
    .el-tree {
      .el-tree-node__content > .el-tree-node__expand-icon {
        padding-left: 8px;
        color:#A6A6A6;
        margin-right: 8px;
      }
    }
  }
  .par-top {
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    border-bottom: 1px solid #e6e6e6;
    .close {
      cursor: pointer;
    }
  }
  .par-content-left {
    // margin-right: 20px;
  }
  .par-content {
    display: flex;
    justify-content: space-between;
    // padding: 20px 0;
    border-bottom: 1px solid #e6e6e6;
    height: 0;
    flex: 1;

  }
  .tag-box {
    width: 211px;
    border-right: 1px solid #e6e6e6;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    overflow-x: hidden;
    .tag-item {
      padding: 4px 6px;
      background-color: rgba(32, 32, 32, 0.08);
      color: rgba(32, 32, 32, 0.60);
      border-radius: 4px;
      display: inline-block;
      cursor: pointer;
      &.check {
        box-shadow: inset 0 0 0 1px #2682FF;
        color: #2682FF;
        background-color: rgba(38, 130, 255, 0.16);
      }
    }
  }
  .par-content-right {
    border-left: 1px solid #e6e6e6;
    display: flex;
    flex-direction: column;
    .top-filter {
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px;
      color: rgba(32, 32, 32, 0.4);
      flex-shrink: 0;
      .disabled {
        cursor: not-allowed;
        color: rgba(32, 32, 32, 0.4);
        &:hover {
          color: rgba(32, 32, 32, 0.4);
        }
      }
    }
  }
  .search-content {
    width: 360px;
    height: 100%;
    .all-footer {
      display: flex;
      align-items: center;
      margin: 16px 0 0;
      padding-left: 8px;
      box-sizing: border-box;
      font-size: 14px;
      @include fontColorOpacity(.6);
      cursor: pointer;
      height: 20px;
      line-height: 20px;
      text-align: center;
      i {
        font-size: 12px;
        color:#A6A6A6;
        margin-right: 14px;
      }
    }
    .group-box {
      padding-top: 10px;
      overflow: auto;
    }
    .top-search {
      height: 54px;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      padding: 0 16px;
      flex-shrink: 0;
      /deep/ {
        .el-input__icon {
          line-height: 54px;
          font-size: 14px;
        }
        .el-input {
          height: 100%;
        }
        .el-input__inner {
          height: 100%;
          border: 0 none !important;
          &:hover {
            border: 0 none !important;
          }
        }
        .el-input__prefix i{
          color: rgba(32, 32, 32, 0.8);
        }
      }
    }
  }

  .checked-list {
    width: 362px;
    overflow: auto;
    padding:0 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    position: relative;
    height:0;
    flex: 1;
    .checked-box {
      > span {
        color: rgba(32, 32, 32, 0.6);
        font-size: 14px;
        padding: 8px 16px;
        overflow: hidden;
        display: block;
      }
    }
    .checked-item {
      cursor: pointer;
      padding: 0 16px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .del {
        display: none;
      }
      .flex {
        display: flex;
        align-items: center;
      }
      .avatar-box {
        margin-right: 15px;
      }
    }
    .checked-item:hover {
      background-color: rgba(32, 32, 32, 0.04);
    }
    .checked-item:hover > .del {
      display: inline-block;
    }
  }
  .search-content {
    display: flex;
    flex-direction: column;
  }
  .colleagues-list {
    padding: 5px;
    display: block;
    margin-left: 0;
  }
  .search-content .colleagues-list .el-checkbox__label {
    display: flex;
  }
  .par-bottom {
    display: flex;
    width: 100%;
    height: 64px;
    padding: 0 24px;
    box-sizing: border-box;
    justify-content: space-between;
  }
  .check-info {
    display: flex;
    align-items: center;
  }
  .check-info .avatar-box {
    margin-right: 20px;
  }
  .el-cascader-panel {
    margin-top: 10px;
    height: 257px;
  }
  .no-list {
    margin-top: 10px;
  }
  .is-disabled {
    opacity: 0.4;
    * {
      cursor: not-allowed;
    }
  }
}
</style>
